export const ignoredModules = new Set([
  "_http_agent",
  "_http_client",
  "_http_common",
  "_http_incoming",
  "_http_outgoing",
  "_http_server",
  "_stream_duplex",
  "_stream_passthrough",
  "_stream_readable",
  "_stream_transform",
  "_stream_writable",
  "_stream_wrap",
  "_tls_common",
  "_tls_wrap",
  "child_process",
  "constants",
  "cluster",
  "domain",
  "inspector",
  "inspector/promises",
  "punycode",
  "readline",
  "readline/promises",
  "repl",
  "tty",
  "v8",
  "vm",
  "wasi",
  "worker_threads",
]);
